// //export const baseUrl =  'http://89.116.187.234:10053'; /** Radix Backend Oracle Server */
// // const radixTest = process.env.REACT_APP_TAX_APP_URL;
// const radixTest = localStorage.getItem("taxRestUrl");
// console.log('Radix Oracle URL:', radixTest);
// export const getBaseUrl = (service) => {
//     console.log('Param service is:', service);
//   switch (service) {
//     case 'RADIXDB':
//        return radixTest;
//     case 'RADIXAPPSDB':
//       return radixTest;
//     default:
//       return radixTest;
//   }
// };

// // console.log('Radix Oracle URL:', radixTest);

// export const taxDbName = 'RADIXDB'; //DEV
// //export const taxDbName = 'RADIXAPPSDB';   //PROD

// export const baseUrl = getBaseUrl(taxDbName);
// // console.log('Tax_Reactjs_taxDbName, baseUrl is:', taxDbName, baseUrl);

import axios from 'axios';

const getStoredTaxRestUrl = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return '';
    }
    return window.localStorage.getItem('taxRestUrl') || '';
};

export const taxDbName = 'RADIXDB'; //DEV
//export const taxDbName = 'RADIXAPPSDB';   //PROD

export const getBaseUrl = (service) => {
    const storedUrl = getStoredTaxRestUrl();

    switch (service) {
        case 'RADIXDB':
        case 'RADIXAPPSDB':
        default:
            return storedUrl;
    }
};

export const setBaseUrl = (url) => {
    const nextBaseUrl = url || getBaseUrl(taxDbName);
    axios.defaults.baseURL = nextBaseUrl;
    return nextBaseUrl;
};

export const baseUrl = setBaseUrl();